import { render, staticRenderFns } from "./GlobalPresence.vue?vue&type=template&id=5f0068bb&scoped=true"
import script from "./GlobalPresence.vue?vue&type=script&lang=js"
export * from "./GlobalPresence.vue?vue&type=script&lang=js"
import style0 from "./GlobalPresence.vue?vue&type=style&index=0&id=5f0068bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0068bb",
  null
  
)

export default component.exports